export var EStaticFilterOperator;
(function (EStaticFilterOperator) {
    EStaticFilterOperator["GREATER_THAN"] = ">";
    EStaticFilterOperator["SMALLER_THAN"] = "<";
    EStaticFilterOperator["EQUAL"] = "=";
})(EStaticFilterOperator || (EStaticFilterOperator = {}));
export var ESortOrder;
(function (ESortOrder) {
    ESortOrder["ASCENDING"] = "ASC";
    ESortOrder["DESCENDING"] = "DESC";
})(ESortOrder || (ESortOrder = {}));
